import styles from "./styles.module.scss";
import _ from "lodash";
import cx from "classnames";

import Tooltip from "src/components/tooltip";
import { IntegrationCapability, IntegrationCapabilityList } from "src/types/settings/dashboard";
import { applicationPlatformTypes , CapabilityPlatformTypesEnum  , externalLinkTypes  } from "src/types/settings/profile";

interface StackProgressBarProps {
  stacks: IntegrationCapabilityList;
  classnames?: string;
}

const StackProgressBar = ({
  stacks,
  classnames,
}: StackProgressBarProps) => {


  // Methods
  const checkStackStatus = (stack: IntegrationCapability) => { // check for stack status activated or deActivated
    return stack.status === 'activated';
  }
  
  return (
    <div className={cx(styles.container, classnames)}>
      <div className={styles.contentContainer}>
        <p className={styles.content}>
          {" "}
          <span className={styles.contentBold}>
            {_.size(
              _.filter( // filter the completed item's
                stacks,
                (stack) => checkStackStatus(stack),
              ),
            )}
          </span>
          /{_.size(stacks)} actions done!
        </p>
      </div>
      <div className={styles.progressWrapper}>
        {_.map(
          _.orderBy(
            stacks,
            [(stack) => checkStackStatus(stack)],
            ["desc"],
          ),
          (stack, index) => (
            <div key={index} className={cx(styles.progressContainer, {[styles.activeProgressHover]: (_.size(stacks) > 5 && checkStackStatus(stack))})}>
              { _.size(stacks) <= 5 ? // less than 5 items & 5
                  <span
                className={
                  checkStackStatus(stack)
                    ? styles.activeProgress
                    : styles.progress
                }> 
                </span>
              :  // More than 5 items
                 checkStackStatus(stack)
                 ? // completed
                 <Tooltip 
                   className={styles.tooltips}
                    content={
                      <p className={styles.tooltipContent}>
                          <i className={cx("paperflite-tick", styles.tickIcon)} />
                          <span>
                            {stack.productCapabilityResponse.name}
                          </span>
                      </p>
                    }
                    placement="bottom"
                  >
                                <span
                      className={
                      styles.activeProgress}> 
                    </span>
                </Tooltip>
                 : // pending
                  <span
                   className={styles.progress}> 
                  </span>  
              }

              {/* only for less than 5 & 5 */}
              { _.size(stacks) <= 5 && checkStackStatus(stack) && 
                ( <p className={styles.progressContent}>
                  <i className={cx("paperflite-tick", styles.tickIcon)} />
                  <Tooltip
                    content={stack.productCapabilityResponse.name}
                    placement="auto"
                  >
                    <span className={styles.contentTruncate}>
                      {stack.productCapabilityResponse.name}
                    </span>
                  </Tooltip>
                </p>
              )} 
            </div>
          )
        )} 
      </div>
    </div>
  );
};

export default StackProgressBar;
